import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import PriceMessageType from 'apps/products/models/PriceMessageType';

const PRICE_MESSAGE_TYPE_TO_TEXT_MAPPING = {
  [PriceMessageType.FROM_GROUP]: 'From',
  [PriceMessageType.TYPICAL_GROUP]: 'Typical price',
  [PriceMessageType.TYPICAL_REGULAR]: 'Typically',
};

export default function PriceTypical(props) {
  const { messageType, className } = props;

  return messageType
    ? <span className={classNames('price-typical', className)}>{PRICE_MESSAGE_TYPE_TO_TEXT_MAPPING[messageType]}</span>
    : null;
}

PriceTypical.propTypes = {
  messageType: PropTypes.oneOf(Object.keys(PriceMessageType)),
  className: PropTypes.string,
};
